export const server = process.env.REACT_APP_BACKEND_URL;